import React, { useEffect, useState } from 'react';
import { UserBankAccount } from '../Classes';
import { Button, Header, Icon, Items } from 'react-frontier';
import Modal from './Modal';
import API from '../API';

interface SelectBankAccountModalProps{
	open: boolean,
	onClose: ()=>void,
	onSelected: (account: UserBankAccount)=>void,
}

var SelectBankAccountModal = (props: SelectBankAccountModalProps)=>{
	var [loadError, setLoadError] = useState<string>(null);
	var [accounts, setAccounts] = useState<UserBankAccount[]>(null);
	var [selected, setSelected] = useState<number>(null);

	useEffect(()=>{
		if(props.open){
			setSelected(null);
		}
		if(props.open && !accounts){
			setLoadError(null);
			API.getUserBankAccounts().then(res=>{
				if(res.error) return setLoadError(res.message);
				setAccounts(res.data);
			}).catch(err=>{
				setLoadError('Hubo un error inesperado cargando las cuentas bancarias (LCL-SBKMDL-1)');
			});
		}
	}, [props.open]);

	var onSelected = ()=>{
		if(!selected) return;
		var account = accounts.find(a=>a.account_id===selected);
		if(!account) return;
		return props.onSelected(account);
	}
	
	return <Modal open={props.open} onClose={props.onClose} size='tiny'>
		<Modal.Header text='Cuentas bancarias' />
		<Modal.Content>
			{accounts ? (
				<Items
					single
					toggle
					selectable
					selected={selected}
					data={accounts}
					valueExtractor={a=>a.account_id}
					onSelected={a=>setSelected(a.account_id)}
					render={a=>(
						<div className='data' style={{ display: 'flex', alignItems: 'center' }}>
							<Icon name={a.clabe ? 'landmark' : 'credit-card'} />
							<div className="info">
								<b>{!a.clabe ? a.bank : 'SPEI'}</b> **{a.clabe ? a.clabe.slice(-5) : a.card_number.slice(-4)}
								<div className="number" style={{ color: 'gray', fontSize: 12, lineHeight: '12px' }}>
									{a.name_account}
								</div>
							</div>
						</div>
					)}
				/>
			) : (
				loadError ? (
					<Header text='Error' subtext={loadError} style={{ paddingTop: 0, margin: '30px 0' }} />
				) : (
					<Header loading text='Cargando' style={{ paddingTop: 0, margin: '30px 0' }} />
				)
			)}
		</Modal.Content>
		<Modal.Actions>
			<Button basic text='Cancelar' onClick={props.onClose} />
			<Button disabled={!accounts || !selected} text="Seleccionar" color='black' onClick={onSelected} />
		</Modal.Actions>
	</Modal>
}

export default SelectBankAccountModal;